import store from '../../../store';

export default (to, from, next) => {
    if (store.getters['role'] == 3) {
        next();
    } else {
        next({ name: 'home' });
    }
}